import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

const MoveDishDialog = ({ open, dish, categories, onClose, onMove }) => {
  const [target, setTarget] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setTarget(null);
  }, [open]);

  const options = categories.filter((category) => !dish || category.id !== dish.categoryId);

  const move = async () => {
    setSaving(true);
    try {
      if (await onMove(dish, target.id)) {
        onClose();
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Move “{dish ? dish.name : ''}”</DialogTitle>
      <DialogContent>
        <Autocomplete
          options={options}
          getOptionLabel={(category) => category.name || 'Untitled'}
          value={target}
          onChange={(event, value) => setTarget(value)}
          renderInput={(params) => <TextField {...params} label="Move to category" autoFocus sx={{ mt: 1 }} />}
        />
      </DialogContent>
      <DialogActions>
        <Button color="inherit" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" disableElevation onClick={move} disabled={!target || saving}>
          Move
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MoveDishDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  dish: PropTypes.object,
  categories: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
};

export default MoveDishDialog;
